import angular from 'angular';

import dashboardExportModule from '../dashboard.export/dashboard.export.module';
import { routesConfig } from './dashboard.routes';

export default angular
  .module('dashboard', [dashboardExportModule.name])
  .config(routesConfig);
